import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {BrowserModule} from '@angular/platform-browser';

import {AuthModule} from 'auth/auth.module';
import {LanguageDropdownModule} from 'shared/language-dropdown/language-dropdown.module';
import {AdminWebAppRoutingModule} from './app-routing.module';
import {ApptextsModule} from './modules/apptexts/apptexts.module';
import {ConstructsDetailsModule} from './modules/constructs/constructs-details/constructs-details.module';
import {ConstructsOverviewModule} from './modules/constructs/constructs-overview/constructs-overview.module';
import {DialogsDetailsModule} from './modules/dialogs/dialogs-details/dialogs-details.module';
import {DialogsOverviewModule} from './modules/dialogs/dialogs-overview/dialogs-overview.module';
import {TreeListModule} from './modules/dynamic-tips/tree-list/tree-list.module';
import {TreeViewModule} from './modules/dynamic-tips/tree-view/tree-view.module';
import {EventRegistrationModule} from './modules/event-registration/event-registration.module';
import {ExportModule} from './modules/export/export.module';
import {HomeModule} from './modules/home/home.module';
import {LoginModule} from './modules/login/login.module';
import {NavbarModule} from './modules/navbar/navbar.module';
import {QuestionsDetailsModule} from './modules/questions/questions-details/questions-details.module';
import {QuestionsOverviewModule} from './modules/questions/questions-overview/questions-overview.module';
import {BadgesDetailsModule} from './modules/badges/badges-details/badges-details.module';
import {BadgesOverviewModule} from './modules/badges/badges-overview/badges-overview.module';
import {ContentsDetailsModule} from './modules/contents/contents-details/contents-details.module';
import {ContentsOverviewModule} from './modules/contents/contents-overview/contents-overview.module';
import {CategoriesModule} from './modules/target-groups/categories/categories.module';
import {CompaniesModule} from './modules/target-groups/companies/companies.module';
import {GroupsModule} from './modules/target-groups/groups/groups.module';
import {ManagementLevelModule} from './modules/target-groups/management-level/management-level.module';
import {TargetGroupsDetailsModule} from './modules/target-groups/target-groups-details/target-groups-details.module';
import {TargetGroupsListModule} from './modules/target-groups/target-groups-list/target-groups-list.module';
// import {TimelineModule} from './modules/timeline/timeline.module';
import {TipListDetailsModule} from './modules/tip-list/tip-list-details/tip-list-details.module';
import {TipListOverviewModule} from './modules/tip-list/tip-list-overview/tip-list-overview.module';
import {ThesisDetailsModule} from './modules/thesis/thesis-details/thesis-details.module';
import {ThesisOverviewModule} from './modules/thesis/thesis-overview/thesis-overview.module';
import {UserDetailsModule} from './modules/user/user-details/user-details.module';
import {UserImportModule} from './modules/user/user-import/user-import.module';
import {UserListModule} from './modules/user/user-list/user-list.module';
import {VoucherDomainsModule} from './modules/voucher/voucher-domains/voucher-domains.module';
import {VoucherGenModule} from './modules/voucher/voucher-gen/voucher-gen.module';

import {AppComponent} from './app.component';

import {LoginGuard} from 'guards/login.guard';

import {DragulaModule} from 'ng2-dragula'

import {ChartsModule}  from 'ng2-charts';
import { CModulesDetailsModule } from './modules/cmodules/cmodules-details/cmodules-details.module';
import { CModulesOverviewModule } from './modules/cmodules/cmodules-overview/cmodules-overview.module';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AdminWebAppRoutingModule,
    AuthModule,
    LanguageDropdownModule,
    DialogsDetailsModule,
    DialogsOverviewModule,
    ConstructsOverviewModule,
    ConstructsDetailsModule,
    LoginModule,
    NavbarModule,
    HomeModule,
    UserDetailsModule,
    UserListModule,
    UserImportModule,
    ApptextsModule,
    QuestionsDetailsModule,
    QuestionsOverviewModule,
    BadgesDetailsModule,
    BadgesOverviewModule,
    ContentsDetailsModule,
    ContentsOverviewModule,
    CModulesDetailsModule,
    CModulesOverviewModule,
    TipListDetailsModule,
    TipListOverviewModule,
    ThesisDetailsModule,
    ThesisOverviewModule,
    VoucherGenModule,
    VoucherDomainsModule,
    EventRegistrationModule,
    // TimelineModule,
    ExportModule,
    TreeViewModule,
    TreeListModule,
    TipListDetailsModule,
    TipListOverviewModule,
    GroupsModule,
    CategoriesModule,
    ManagementLevelModule,
    CompaniesModule,
    TargetGroupsListModule,
    TargetGroupsDetailsModule,
    DragulaModule,
    ChartsModule
  ],
  providers: [
    LoginGuard,
  ],
  bootstrap: [
    AppComponent,
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/app.module.ts